import React from 'react';

interface StatsCardProps {
    title: string;
    value: number;
    className?: string;
}

const StatsCard: React.FC<StatsCardProps> = ({ title, value, className = '' }) => {
    return (
        <div
            className={`flex flex-col gap-2 px-6 py-4 rounded-xl ${className}`}
        >
            <h3 className="text-sm font-inter font-semibold dark:text-[#E4E4EB] text-[#555770]">{title}</h3>
            <div className="flex items-center">
                <span className="text-2xl font-inter font-semibold dark:text-white text-[#28293D]">
                    {value?.toLocaleString() || 0}
                </span>
            </div>
        </div>
    );
};

export default StatsCard;

